/* ============================================================
   TOUR DATES (tour-dates.js) — KEM's OWN tour data
   ------------------------------------------------------------
   The Tour tab's "On The Road" card renders from THIS file —
   independent of Bandsintown. Populate it however you like:
   tell Claude ("add a show: Oct 9, Webster Hall NYC, tickets
   link …"), edit by hand, or script it. Bandsintown is only the
   FALLBACK when this list is empty, plus a small credit link.

   Row format:
     date    display date, e.g. 'OCT 09'
     city    'New York, NY'
     venue   'Webster Hall'
     link    ticket URL ('' = no link yet)
     status  'onsale' | 'low' | 'soldout' | 'announced'
     flyer   OPTIONAL poster image (e.g. 'assets/flyers/oside.jpg')
             — when set, this show's ad card in the feed rotation
             renders the flyer full-bleed instead of the default
             designed card. Drop images in assets/flyers/.

   Statuses: onsale → "Tickets" | low → "Low stock" | soldout →
   "Sold out" | announced → "Soon" | free → "Free show"
   ============================================================ */

const TOUR_DATES = [
  /* CONFIRMED — Oside Flavor (The Osider / Pier Club), Sept 16 2026,
     5-9 PM, SoCal Sports Complex, Oceanside CA. Obed headlines with
     The Cherry Bombs, CHZBRGR, Zochi. 21+. Source: official flier. */
  { date: 'SEP 16', city: 'Oceanside, CA',
    venue: 'Oside Flavor · SoCal Sports Complex · 5-9 PM · 21+',
    link: 'https://osideflavor.com', status: 'onsale' },
  /* CONFIRMED — AmericanaFest 2026 (Nashville, Sept 15-19):
     Obed plays Musicians Corner at Centennial Park on Sept 18,
     on a bill with Jake Bugg, INK, and She Returns From War.
     Source: AmericanaFest full schedule (Aug 2026).            */
  { date: 'SEP 18', city: 'Nashville, TN',
    venue: 'Musicians Corner, Centennial Park · AMERICANAFEST',
    link: 'https://www.musicianscornernashville.com/', status: 'free' },
  /* Add the rest of the fall run (Texas, California, the South)
     here as dates are confirmed — tell Claude or edit directly. */
];

const TourDates = (() => {
  const STATUS = {
    onsale:    { label: 'Tickets',   cls: 'onsale' },
    low:       { label: 'Low stock', cls: 'low' },
    soldout:   { label: 'Sold out',  cls: 'soldout' },
    announced: { label: 'Soon',      cls: 'announced' },
    free:      { label: 'Free show', cls: 'onsale' },
  };

  function render(body) {
    body.innerHTML = `
      <div class="ticket__shows bit-shows">
        ${TOUR_DATES.map(s => {
          const st = STATUS[s.status] || STATUS.announced;
          const inner = `
            <span class="ticket__date">${s.date}</span>
            <span class="ticket__city">${s.city}</span>
            <span class="ticket__venue">${s.venue} ·
              <em class="tour-status tour-status--${st.cls}">${st.label}</em></span>`;
          return s.link && s.status !== 'soldout'
            ? `<a class="ticket__show bit-show" href="${s.link}" target="_blank" rel="noopener">${inner}</a>`
            : `<div class="ticket__show">${inner}</div>`;
        }).join('')}
      </div>`;
  }

  return { render, hasDates: () => TOUR_DATES.length > 0 };
})();
